<template>
  <el-dialog
    show-close
    visible
    width="800px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    append-to-body
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :disabled="disabled"
      :amzMarketCode="amzMarketCode"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    type: { type: String, default: '' },
    amzMarketCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('dialog_title_edit') || '编辑亚马逊市场',
        add: this.$l('dialog_title_add') || '新增亚马逊市场',
        detail: this.$l('dialog_title_detail') || '亚马逊市场详情',
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
